export const MenuTypeEnum = {
    VEGETARIAN: 'vegetarian',
    REGULAR: 'regular',
};
